import { gql } from "@apollo/client";

export const SEND_ASSISTANT_MESSAGE = gql`
  mutation SendAssistantMessage(
    $requestId: UUID
    $retry: Boolean
    $message: String!
    $conversationId: String
    $classId: ID
    $creation: GenericScalar
    $assignmentId: ID
  ) {
    sendAssistantMessage(
      requestId: $requestId
      retry: $retry
      message: $message
      conversationId: $conversationId
      classId: $classId
      creation: $creation
      assignmentId: $assignmentId
    ) {
      message
      conversationId
      error
      errorCode
      requestId
      requestStatus
      responseCount
      responseLimit
      limitReached
      assignmentName
      className
    }
  }
`;

export const RECORD_PROMPT_USAGE = gql`
  mutation RecordPromptUsage(
    $promptText: String!
    $conversationId: String!
    $contextData: JSONString
  ) {
    recordPromptUsage(
      promptText: $promptText
      conversationId: $conversationId
      contextData: $contextData
    ) {
      success
      error
    }
  }
`;

export const UPDATE_CONVERSATION_TITLE = gql`
  mutation UpdateConversationTitle($conversationId: String!, $title: String!) {
    updateConversationTitle(conversationId: $conversationId, title: $title) {
      success
      error
      conversation {
        id
        title
      }
    }
  }
`;

export const PERFORM_ASSISTANT_ACTION = gql`
  mutation PerformAssistantAction(
    $actionId: ID!
    $operation: String!
    $revision: String
  ) {
    performAssistantAction(
      actionId: $actionId
      operation: $operation
      revision: $revision
    ) {
      success
      error
      action
    }
  }
`;
